<template>
  <div class="accordion-wrapper">
    <div class="accordion-wrapper__head" @click="emit('click:head')">
      <slot name="head"></slot>
    </div>
    <div>
      <div class="accordion-wrapper__body" :class="{ 'accordion-wrapper__body--minimized': !expanded }" @click="emit('click:body')">
        <div class="inner-grid-transitioner">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup lang="ts">
  import { toRefs } from 'vue'
  
  const emit = defineEmits(['click:head', 'click:body'])
  
  const props = defineProps({
      expanded: {
        type: Boolean,
        default: false
      }
  })
  
  const { expanded } = toRefs(props)
</script>
  
<style lang="scss" scoped>

  .accordion-wrapper {
    display: flex;
    flex-direction: column;
    flex-shrink: 1;
    opacity: 1;

    &__head {
      width: 100%;
      overflow: hidden;
    }

    &__body {
      display: grid;
      grid-template-rows: 1fr;
      transition: grid-template-rows 0.3s ease-out;

      &--minimized {
        grid-template-rows: 0fr;
        margin-top: 0px;
        transition: grid-template-rows 0.3s ease-out;
      }
    }
  }
    
  .accordion-submenu {
    margin-left: 1rem;
    border-left: 1px solid #FFBABC;

    &__element {
      width: 100%;
      padding-left: 1rem;
      padding-right: 1rem;
      text-overflow: ellipsis;
      overflow-x: hidden;
    }
  }

  .inner-grid-transitioner {
    overflow: hidden;
  }


</style>
